// Centralized semantic reason constants for SupportTicketService snapshot publications.
// Using a const object provides autocompletion and typo safety; union type derives from values.

export const SupportTicketReasons = {
  Init: 'init',
  // Consolidated high-level reasons (Phase: EventNoiseReduction)
  TicketListChanged: 'ticketListChanged', // list fetch, append new ticket, SSE list-only merges
  TicketChanged: 'ticketChanged', // status/metadata changes affecting header/list snapshot
  ConversationChanged: 'conversationChanged', // add/update/delete/load conversation entry mutations
  DraftStateChanged: 'draftStateChanged', // metadata or conversation draft lifecycle events
  NewTicketWorkflow: 'newTicketWorkflow' // begin/create/discard new ticket draft lifecycle
} as const;

export type SupportTicketReason = (typeof SupportTicketReasons)[keyof typeof SupportTicketReasons];

// Reasons that should trigger a user-facing "changes saved" toast.
export const SAVED_TOAST_REASONS: ReadonlySet<SupportTicketAnyReason> = new Set([
  // Unified toast triggers: ticket-level or conversation mutations & draft commits.
  SupportTicketReasons.TicketChanged,
  SupportTicketReasons.ConversationChanged,
  SupportTicketReasons.DraftStateChanged
]);

// Additional non-save semantic reasons (kept separate for clarity)
export const SupportTicketNonSaveReasons = {
  DiscardDraftConversationEntry: 'discardDraftConversationEntry' // kept for legacy specific UI flows
} as const;

export type SupportTicketNonSaveReason = (typeof SupportTicketNonSaveReasons)[keyof typeof SupportTicketNonSaveReasons];

// Convenience union for publish signature
export type SupportTicketAnyReason = SupportTicketReason | SupportTicketNonSaveReason;
